<div class="cf-flex-column">
  <label
    class="ac-form-field-label cf-flex"
    [ngClass]="{ 'ac-form-field-label-disabled': disabled, 'ac-form-field-label-readonly': readOnly }"
  >
    <span>{{ labelTextId | translate }}</span>
    <span *ngIf="required" class="required-sign"> *</span></label
  >
  <mat-form-field [attr.data-test]="propertyKey" class="cf-flex" appearance="outline" [subscriptSizing]="subscriptSizing || 'dynamic'">
    <input
      matInput
      [type]="hide ? 'password' : 'text'"
      [formControl]="inputControl"
      (focus)="focusChange.emit(true)"
      (blur)="focusChange.emit(false)"
    />
    <button matSuffix mat-icon-button type="button" disableRipple="true" aria-label="Toggle visibility" (click)="hide = !hide">
      <mat-icon *ngIf="!hide" svgIcon="visibility"></mat-icon>
      <mat-icon *ngIf="hide" svgIcon="visibility_off"></mat-icon>
    </button>
    <mat-error *ngIf="inputControl.errors && inputControl.errors[passwordRequirementsValidationErrorKey]" translate>
      UI.Common.Validation.PasswordRequirements
    </mat-error>
    <mat-error *ngIf="inputControl.errors && inputControl.errors['required']" translate> UI.Common.Validation.ValueRequired </mat-error>
    <mat-error
      *ngIf="inputControl.errors && inputControl.errors['minlength']"
      translate
      [translateParams]="{ minLength: inputControl.errors['minlength']['requiredLength'], currentLength: inputControl.value?.length || 0 }"
    >
      UI.Common.Validation.ValueTooShort
    </mat-error>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  </mat-form-field>
  <ng-content></ng-content>
</div>
